const state = {
  appLangs: 'zh',
  appObj: {
    'X-Atayun-Token': '1_1088180_i63xsgTFIG_oRh5mEFTIGw'
  }
}
const mutations = {
  // 设置app语言
  setAppLang (state, lang) {
    state.appLangs = lang
    console.log(state.appLangs, '::')
  },
  setAppObj (state, lang) {
    state.appObj = lang
    console.log(state.appObj, '::')
  }

}
export default {
  namespaced: true,
  state,
  mutations
}
